import { useState } from 'react'

export default function useModalVisibilityControls(defaultValue = false) {
  const [modalVisible, setModalVisible] = useState(defaultValue)
  const openModal = () => setModalVisible(true)
  const closeModal = () => setModalVisible(false)
  const toggleModal = () => setModalVisible(!modalVisible)

  return {
    modalVisible,
    setModalVisible,

    openModal,
    closeModal,
    toggleModal
  }
}
